export default {
  textCardLogged: (
    <>
      Utilizza questa illustrazione scientifica <br /> insieme a oltre 75.000 opzioni aggiuntive.{' '}
      <br /> Crea bellissimi design scientifici <br /> in pochi minuti.
    </>
  ),
  startCreatingNow: 'Inizia a Creare Ora',
  loginForm: {
    login: 'Accedi al tuo account',
    joinUs: 'Unisciti a noi gratuitamente',
  },
  registerFooter: {
    member: 'Già un membro?',
    login: 'Fai il login invece',
  },
  initDescription: 'il',
  description:
    "è l'opzione più adatta al vostro modello di infografica brillante. Create bellissime infografiche e presentazioni scientifiche, accademiche ed educative con questa illustrazione.",
  customizeInit: 'Personalizzare il',
  customizeDescription:
    "Se necessario, è possibile eseguire un'illustrazione e scaricare, presentare o condividere subito il proprio lavoro. Questo è un modello di infografica realizzato da scienziati.",
};
